import gql from 'graphql-tag'

export const QUERY_PRICE_RANGES_ANALYTICS_LIST = gql`
  query PriceRangesAnalyticsList(
    $page: Int
    $pageSize: Int
    $search: String
    $sort: [String]
    $sortDirection: [SortDirection]
    $units: [ID]
    $products: [String]
  ) {
    priceRangesAnalyticsList(
      page: $page
      pageSize: $pageSize
      search: $search
      sort: $sort
      sortDirection: $sortDirection
      units: $units
      products: $products
    ) {
      records
      page
      priceRangesAnalyticsList {
        _id
        description
        name
        type
        products_count
        ranges_count
        created_at
        updated_at
      }
    }
  }
`

export const QUERY_PRICE_RANGES_ANALYTIC = gql`
  query PriceRangesAnalytics($_id: ID!) {
    priceRangesAnalytics(_id: $_id) {
      _id
      name
      description
      type
      price_ranges {
        price_range_index
        products_metrics {
          product {
            sku
            ean
            eans
            name
            price
          }
          price_range_metric {
            percentil_20
            percentil_50
            percentil_80
            min_price
            max_price
            unique
            upsell
            downsell
            new
            lost
          }
        }
        price_range_metric {
          percentil_20
          percentil_50
          percentil_80
          min_price
          max_price
          unique
          upsell
          downsell
          new
          lost
        }
      }
      filters {
        campaign {
          _id
          type
        }
        reference_period_start
        reference_period_end
        period_start
        period_end
        range_count
        products
        units
      }
    }
  }
`

export const QUERY_PRODUCTS_WITHOUT_SALES = gql`
  query ProductsWithoutSales($reference_period_start: String!, $reference_period_end: String!, $products: [String!]!, $units: [ID]!) {
    productsWithoutSales(reference_period_start: $reference_period_start, reference_period_end: $reference_period_end, products: $products, units: $units) {
      products {
        ean
        eans
        name
        sku
      }
    }
  }
`

export const QUERY_GENERATE_PRICE_RANGES_HISTOGRAM = gql`
  query GeneratePriceRangesHistogram(
    $reference_period_start: String!
    $reference_period_end: String!
    $period_start: String!
    $period_end: String!
    $products: [InputPriceRangesProduct!]!
    $products_without_sales: [InputPriceRangesProductPrice]!
    $units: [ID]
    $range_count: Int!
  ) {
    generatePriceRangesHistogram(
      reference_period_start: $reference_period_start
      reference_period_end: $reference_period_end
      period_start: $period_start
      period_end: $period_end
      products: $products
      products_without_sales: $products_without_sales
      range_count: $range_count
      units: $units
    ) {
      price_range_index
      price_range_metric {
        percentil_20
        percentil_50
        percentil_80
        max_price
        min_price
      }
      products_metrics {
        product {
          sku
          name
          price
        }
        price_range_metric {
          percentil_80
          percentil_20
        }
      }
    }
  }
`

export const QUERY_GENERATE_PRICE_RANGES_ANALYTICS = gql`
  query GeneratePriceRangesAnalytics(
    $reference_period_start: String!
    $reference_period_end: String!
    $period_start: String!
    $period_end: String!
    $price_ranges: [InputPriceRangeBeforeAnalytics]!
    $units: [ID]
    $range_count: Int!
  ) {
    generatePriceRangesAnalytics(
      reference_period_start: $reference_period_start
      reference_period_end: $reference_period_end
      period_start: $period_start
      period_end: $period_end
      price_ranges: $price_ranges
      range_count: $range_count
      units: $units
    ) {
      price_range_index
      price_range_metric {
        percentil_20
        percentil_50
        percentil_80
        max_price
        min_price
        unique
        upsell
        downsell
        new
        lost
      }
      products_metrics {
        product {
          sku
          name
          price
        }
        price_range_metric {
          percentil_20
          percentil_50
          percentil_80
          min_price
          max_price
          unique
          upsell
          downsell
          new
          lost
        }
      }
    }
  }
`

export const MUTATION_UPSERT_PRICE_RANGE_ANALYTICS = gql`
  mutation UpsertPriceRangesAnalytics($data: InputPriceRangesAnalytics!) {
    upsertPriceRangesAnalytics(data: $data) {
      _id
      message
    }
  }
`

export const MUTATION_DELETE_PRICE_RANGE_ANALYTICS = gql`
  mutation DeletePriceRangesAnalytics($_id: ID!) {
    deletePriceRangesAnalytics(_id: $_id)
  }
`

export const QUERY_PRODUCTS_BY_SKUS = gql`
  query Products($skus: [String]) {
    products(skus: $skus) {
      products {
        _id
        sku
        ean
        eans
        name
      }
    }
  }
`
